import React, { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { AlertTriangle, ShieldCheck } from "lucide-react";

export default function Checker() {
  const [alerts, setAlerts] = useState([]);
  const load = useCallback(async () => {
    try {
      const r = await api.get("/checker/alerts");
      setAlerts(r.data);
    } catch (e) {
      console.error("Gagal memuat alert:", e);
    }
  }, []);
  useEffect(() => { load(); }, [load]);
  const red = alerts.filter(a => a.severity === "red");
  const yellow = alerts.filter(a => a.severity === "yellow");
  return (
    <div data-testid="page-checker" className="space-y-6">
      <div>
        <div className="text-xs font-mono uppercase tracking-widest text-slate-500 mb-2">Kontrol Anti-Selisih</div>
        <h1 className="font-display text-3xl font-bold text-slate-900">Stock Checker</h1>
        <p className="text-slate-500 text-sm mt-1">Daftar masalah terdeteksi. Merah = kritis, Kuning = perlu perhatian.</p>
      </div>

      {alerts.length === 0 && (
        <Card className="p-10 flex flex-col items-center text-center">
          <div className="h-14 w-14 rounded-full bg-emerald-500 grid place-items-center mb-4"><ShieldCheck className="h-7 w-7 text-white" /></div>
          <div className="font-display text-xl font-bold text-emerald-800">STOK TERKONTROL</div>
          <div className="text-sm text-slate-500 mt-1">Tidak ada anomali stok terdeteksi.</div>
        </Card>
      )}

      {red.length > 0 && (
        <div>
          <div className="text-xs font-mono uppercase tracking-widest text-rose-600 mb-2">Kritis ({red.length})</div>
          <div className="grid gap-2">
            {red.map((a) => (
              <div key={`red-${a.title}|${a.message}`} data-testid="alert-red" className="bg-rose-50 border-l-4 border-rose-500 border border-rose-200 rounded p-4 flex items-start gap-3">
                <AlertTriangle className="h-5 w-5 text-rose-600 shrink-0 mt-0.5" />
                <div><div className="font-semibold text-rose-900">{a.title}</div><div className="text-sm text-rose-800 font-mono mt-0.5">{a.message}</div></div>
              </div>
            ))}
          </div>
        </div>
      )}

      {yellow.length > 0 && (
        <div>
          <div className="text-xs font-mono uppercase tracking-widest text-amber-600 mb-2">Perlu Perhatian ({yellow.length})</div>
          <div className="grid gap-2">
            {yellow.map((a) => (
              <div key={`yellow-${a.title}|${a.message}`} data-testid="alert-yellow" className="bg-amber-50 border-l-4 border-amber-500 border border-amber-200 rounded p-4 flex items-start gap-3">
                <AlertTriangle className="h-5 w-5 text-amber-600 shrink-0 mt-0.5" />
                <div><div className="font-semibold text-amber-900">{a.title}</div><div className="text-sm text-amber-800 font-mono mt-0.5">{a.message}</div></div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
